import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs'
import { useEffect, useState } from 'react'
import { useIntegrationCategories } from '../context/IntegrationCategoriesContext'
import { getFilteredCategories } from 'routes/Integrations/helpers'
import { CategoryCompactType } from 'routes/Integrations/helpers/types'

export function useCategories() {
  const categories = useIntegrationCategories()

  const [filteredCategories, setFilteredCategories] =
    useState<CategoryCompactType[]>(categories)
  const [loadingCategories, setLoadingCategories] = useState<boolean>(true)

  const [filter] = useQueryState(
    'filter',
    parseAsArrayOf(parseAsString, ',').withDefault([]),
  )

  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller

    const fetchData = async () => {
      try {
        setLoadingCategories(true)
        const { safeCategories } = await getFilteredCategories({
          filter,
          signal,
        })
        if (signal?.aborted) return

        setFilteredCategories(safeCategories)
        setLoadingCategories(false)
      } catch (err) {
        console.warn(err)
      }
    }

    fetchData()

    return () => controller.abort()
  }, [filter.length])

  return {
    filteredCategories,
    loadingCategories,
  }
}
